import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FooterWelcomeMobileComponent } from "./footer-welcome-mobile.component";
import { AbsoluteRoutingModule } from "src/app/pipes/absolute-routing/absolute-routing.module";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [FooterWelcomeMobileComponent],
  imports: [CommonModule, AbsoluteRoutingModule, RouterModule],
  exports: [FooterWelcomeMobileComponent],
})
export class FooterWelcomeMobileModule {}
